import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthService } from "../../auth/service/auth.service";

@Injectable({
  providedIn: "root",
})
export class HasRoleGuard {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.getUserRole().pipe(
      map((role) => {
        if (route.data["role"].includes(role)) {
          return true;
        }
        else {
          this.router.navigate(["/404"]);
          return false;
        }
      }),
      catchError((error) => {
        console.error("Error fetching user role", error);
        this.router.navigate(["/auth/login"]);
        return of(false);
      }),
    );
  }
}
